import React from "react";

function Ipad() {
  return (
    <div>
      <h1 className="center">Ipad page</h1>
    </div>
  );
}

export default Ipad;
